const format = function (value, format) {
    if (!value) return '';
    if (!(value instanceof Date)) {
        value = new Date(value.replace(/-/g, "/"));
    }
    let o = {
        'M+': value.getMonth() + 1, // month
        'd+': value.getDate(), // day
        'H+': value.getHours(), // hour
        'm+': value.getMinutes(), // minute
        's+': value.getSeconds(), // second
        'q+': Math.floor((value.getMonth() + 3) / 3), // quarter
        'S': value.getMilliseconds() // millisecond
    };

    if (!format || format === '') {
        format = 'yyyy-MM-dd hh:mm';
    }

    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (value.getFullYear() + '').substr(4 - RegExp.$1.length));
    }

    for (let k in o) {
        if (new RegExp('(' + k + ')').test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
    }
    return format;
};

export {format};